/**
 * Dirty-baseline policy for Form.finalizeInitialFormState().
 *
 * When the user edits before deferred widgets finish hydrating, a late snapshot must NOT
 * fold those edits into the "clean" baseline — otherwise Save stays disabled while
 * leave-confirm can still see later async field rewrites as dirty (REDMINE-2209).
 *
 * @param {{ userInteracted: boolean }} state
 * @returns {'capture-clean' | 'keep-user-edits'}
 */
export function resolveFinalizeBaselineAction({ userInteracted }) {
	return userInteracted ? 'keep-user-edits' : 'capture-clean';
}
